module.exports = __webpack_public_path__ + "885f8c26d430d989e773206f287901cd.svg";